import React from "react";
import LoadingInput from "../../../../../_components/LoadingInput";
import Address from "../../../../../_components/Address";
import Button from "../../../../../_components/Button";
import { toast as toastify } from "react-toastify";
import { editBranch, getCurrentBranchData, getCnaes } from "../../../../../api/branches";
import { getCookieByName } from "../../../../../utils";
import Text from "../../../../../_components/Text";

const IndividualComponent = ({ formData, onChange, type, loading }) => (
    <div className="row">
        <div className="col-md-3 col-xl-3">
            <LoadingInput
                label="Nome"
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={onChange}
                loading={loading}
            />
        </div>
        <div className="col-md-3 col-xl-3">
            <LoadingInput
                label="CPF"
                type="cpf"
                name="individual:cpf"
                value={formData.individual.cpf || ""}
                onChange={onChange}
                loading={loading}
            />
        </div>
        <div className="col-md-3 col-xl-3">
            <LoadingInput
                label="E-mail"
                type="email"
                name="email"
                value={formData.email || ""}
                onChange={onChange}
                loading={loading}
            />
        </div>
        <div className="col-md-3 col-xl-3">
            <LoadingInput
                label="Telefone"
                type="phone_number"
                name="phone_number"
                value={formData.phone_number || ""}
                onChange={onChange}
                loading={loading}
            />
        </div>
        {type === 4 && (
            <div className="col-md-3 col-xl-3">
                <LoadingInput
                    label="Inscrição Municipal"
                    type="text"
                    name="individual:municipal_registry"
                    value={formData.individual.municipal_registry || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
        )}
    </div>
);

const CompanyComponent = ({ formData, onChange, loading }) => (
    <div className="container">
        <div className="row">
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="Razão Social"
                    type="text"
                    name="name"
                    value={formData.name || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="Nome Fantasia"
                    type="text"
                    name="company:fancy_name"
                    value={formData.company.fancy_name || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="CNPJ"
                    type="cnpj"
                    name="company:cnpj"
                    value={formData.company.cnpj || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="E-mail"
                    type="text"
                    name="email"
                    value={formData.email || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="Telefone"
                    type="phone_number"
                    name="phone_number"
                    value={formData.phone_number || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="Inscrição Municipal"
                    type="text"
                    name="company:municipal_registry"
                    value={formData.company.municipal_registry || ""}
                    onChange={onChange}
                    loading={loading}
                />
            </div>
            <div className="col-md-6 mb-3">
                <LoadingInput
                    label="Inscrição Estadual"
                    type="text"
                    name="company:state_registry"
                    value={formData.company.state_registry || ""}
                    onChange={onChange}
                    loading={loading}
                />
                <div className="mt-1">
                    <span
                        style={{ fontSize: "12px", color: "#00A9FF", cursor: "pointer" }}
                        onClick={() => onChange({ target: { name: "company:state_registry", value: "ISENTO" } })}
                    >
                        Preencher como ISENTO
                    </span>
                </div>
            </div>
            <div className="col-md-6 mb-3">
                <LoadingInput
                    onChange={onChange}
                    label="CRT"
                    name="crt"
                    as="select"
                    loading={loading}
                    value={
                        formData.branch && formData.branch.crt
                            ? formData.branch.crt
                            : ""
                    }
                >
                    <option disabled value="">
                        Selecione o CRT
                    </option>
                    <option value="1">1 - Simples Nacional</option>
                    <option value="2">
                        2 - Simples Nacional - Excesso de Sublimite da Receita Bruta
                    </option>
                    <option value="3">3 - Regime Normal</option>
                    <option value="4">4 - Simples Nacional - MEI</option>
                </LoadingInput>
            </div>
            <div className="col-md-6 mb-3">
                {/* CNAE */}
                <LoadingInput
                    label="CNAE"
                    type="text"
                    name="company:cnae:code"
                    loading={loading}
                    value={
                        formData.company &&
                            formData.company.cnae &&
                            formData.company.cnae.code
                            ? formData.company.cnae.code
                            : ""
                    }
                    onChange={onChange}
                />
                <Text>
                    {formData.company &&
                        formData.company.cnae &&
                        formData.company.cnae.description
                        ? formData.company.cnae.description
                        : ""}
                </Text>
            </div>
        </div>
    </div>
);

const EditBranch = () => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({
        branch_type: 0,
        individual: { cpf: "" },
        company: {
            cnpj: "",
            fancy_name: "",
        },
    });

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "company:cnae:code") {
            value = value.replace(/\D/g, "");
        }

        setData((prevData) => {
            const updatedData = { ...prevData };

            if (name === "crt") {
                const crtDescriptions = {
                    1: "Simples Nacional",
                    2: "Simples Nacional - Excesso de Sublimite da Receita Bruta",
                    3: "Regime Normal",
                    4: "Simples Nacional - MEI",
                };
                updatedData.branch = {
                    ...updatedData.branch,
                    crt: Number(value),
                    crt_description: crtDescriptions[value] || "",
                };
            } else if (name.includes(":")) {
                const keys = name.split(":"); // ["company", "cnae", "code"]
                if (keys.length === 3) {
                    if (!updatedData[keys[0]]) {
                        updatedData[keys[0]] = {};
                    }
                    if (!updatedData[keys[0]][keys[1]]) {
                        updatedData[keys[0]][keys[1]] = {};
                    }

                    updatedData[keys[0]][keys[1]][keys[2]] = value;

                    if (
                        keys[0] === "company" &&
                        keys[1] === "cnae" &&
                        keys[2] === "code" &&
                        value.length >= 5
                    ) {
                        setLoading(true);
                        getCnaes({ code: value })
                            .then((resp) => {
                                setLoading(false);
                                if (!resp || resp.length === 0) {
                                    updatedData.company.cnae.description =
                                        "Código não encontrado";
                                    updatedData.company.main_cnae = "";
                                    return;
                                }
                                if (resp.length === 1) {
                                    const cnae = resp[0];
                                    updatedData.company.cnae = {
                                        code: cnae.code,
                                        description: cnae.description,
                                        id: cnae.id,
                                        service_item_code:
                                            cnae.service_item_code || "",
                                    };
                                    updatedData.company.main_cnae = cnae.id;
                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                console.error("Erro ao buscar cnae", error);
                            });
                    } else if (
                        keys[0] === "company" &&
                        keys[1] === "cnae" &&
                        keys[2] === "code" &&
                        value.length < 5
                    ) {
                        updatedData.company.cnae.description = "";
                        updatedData.company.main_cnae = "";
                    }
                } else {
                    updatedData[keys[0]] = {
                        ...updatedData[keys[0]],
                        [keys[1]]: value,
                    };
                }
            } else {
                updatedData[name] = value;
            }

            return updatedData;
        });
    };

    React.useEffect(() => {
        setLoading(true);
        getCurrentBranchData(getCookieByName("branch_owner_id"))
            .then((_data) => {
                if (!_data.company) {
                    _data.company = {}

                }

                if (!_data.individual) {
                    _data.individual = { cpf: "" };
                }

                // Garante que company.cnae é sempre um objeto válido (evita crash no handleChange)
                if (_data.company && !_data.company.cnae) {
                    _data.company.cnae = { code: "", description: "", id: "", service_item_code: "" };
                } else if (_data.company && _data.company.cnae) {
                    _data.company.cnae = {
                        code: _data.company.cnae.code || "",
                        description: _data.company.cnae.description || "",
                        id: _data.company.cnae.id || "",
                        service_item_code: _data.company.cnae.service_item_code || "",
                    };
                }

                setData({
                    ..._data,
                    company: { ..._data.company },
                    individual: _data.individual,
                });
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    React.useEffect(() => {
        setData((prevData) => {
            const newData = { ...prevData };

            if ([1, 4].includes(newData.branch_type)) {
                delete newData.individual.state_registry;
                delete newData.individual.municipal_registry;
                if (!newData.individual) {
                    newData.individual = { cpf: "" };

                }
                if (newData.branch_type === 4) {
                    newData.individual.municipal_registry =
                        newData.individual.municipal_registry || "";
                    delete newData.individual.state_registry;
                }
            } else if ([2, 3].includes(newData.branch_type)) {
                if (!newData.company) {
                    newData.company = {
                        cnpj: "",
                        fancy_name: "",
                        cnae: {
                            code: "",
                            description: "",
                            id: "",
                            service_item_code: "",
                        },
                    };
                } else if (!newData.company.cnae) {
                    // Garante cnae inicializado mesmo quando company já existe
                    newData.company.cnae = { code: "", description: "", id: "", service_item_code: "" };
                }
                delete newData.individual;
            }

            return newData;
        });
    }, [data.branch_type]);

    const handleSubmit = () => {
        let payload = {
            name: data.name,
            email: data.email,
            phone_number: data.phone_number,
            address: {
                ...data.address,
                city_location: data.address.city_id,
                state_location: data.address.state_id,
            },
        };

        if (data.company && data.company.cnpj) {
            payload["branch"] = {
                aliquota_credito: 1,
                is_fiscal: false,
                branch_type: data.branch_type,
                crt: data.branch && data.branch.crt ? data.branch.crt : null,
                main_company: true,
            };

            payload["company"] = {
                ...data.company,
                cnae: {
                    code: data.company.cnae ? data.company.cnae.code : "",
                    description: data.company.cnae ? data.company.cnae.description : "",
                    id: data.company.cnae ? data.company.cnae.id : "",
                    service_item_code: data.company.cnae
                        ? data.company.cnae.service_item_code
                        : "",
                },
                main_cnae: data.company.main_cnae || "",
            };
        } else {
            payload["branch"] = {
                name: data.name,
                aliquota_credito: 0,
                is_fiscal: false,
                branch_type: data.branch_type,
                main_company: true,
            };
            payload["individual"] = data.individual;
        }

        editBranch(data.id, payload)
            .then(() => {
                toastify.success("Filial editada com sucesso!", {
                    position: "top-center",
                });
                setTimeout(() => {
                    window.location.href = "/settings/branch";
                }, 1500);
            })
            .catch((error) => console.error("Erro:", error))
    };

    return (
        <div className="container-fluid">
            {[1, 4].includes(data.branch_type) ? (
                <IndividualComponent
                    type={data.branch_type}
                    formData={data}
                    onChange={handleChange}
                    loading={loading}
                />
            ) : (
                <CompanyComponent formData={data} onChange={handleChange} loading={loading} />
            )}
            <div>
                <Address
                    data={data.address}
                    loading={loading}
                    onChange={(address) =>
                        setData((prevData) => ({ ...prevData, address }))
                    }
                />
            </div>
            <Button className="d-flex justify-content-center mt-3" onClick={handleSubmit}>
                Salvar Alterações
            </Button>
        </div>
    );
};

export default EditBranch;



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Branch/Edit/index.jsx